import React, { useEffect, useState } from 'react'
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader'
import { getUsuarios } from '../../../services/apis';
import { useNavigate } from 'react-router-dom';
import { Button, CircularProgress, Dialog, DialogContent, Divider, Grid, Typography } from '@mui/material';
import { UsuarioCard } from './UsuarioCard';
import { FormCrearUsuario } from './FormCrearUsuario';
import { OpcionesMenuFunc } from '../../../utils/componentes-utiles/OpcionesMenuFunc';
import { EditarUsuario } from './EditarUsuario';

import CancelIcon from '@mui/icons-material/Cancel';
import PersonIcon from '@mui/icons-material/Person';

export const Usuarios = () => {
	const navigate = useNavigate();

	//estados
	const [usuarios, setUsuarios] = useState([]);
	const [departamentos, setDepartamentos] = useState([]);
	const [roles, setRoles] = useState([]);
	const [clientes, setClientes] = useState([]);
	const [opciones, setOpciones] = useState([]);
	const [usuariosClientes, setUsuariosClientes] = useState([]);
	const [usuariosClientesAgrupados, setUsuariosClientesAgrupados] = useState([]);
	const [opcionesUsuario, setOpcionesUsuario] = useState([]);

	const [loaded, setLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [openCleinte, setOpenCliente] = useState(null);


	const handleClose = () => {
		console.log(openCleinte);

		setOpenCliente(null);
	};


	useEffect(() => {
		cargarUsuarios();
	}, [])

	const cargarUsuarios = async () => {
		try {
			const response = await getUsuarios();
			if (response.success == true) {
				console.log(response.data);

				setUsuarios(response.data.usuarios);
				setRoles(response.data.roles);
				setDepartamentos(response.data.departamentos);
				setClientes(response.data.clientes);
				setUsuariosClientes(response.data.usuarios_clientes);
				setUsuariosClientesAgrupados(response.data.usuarios_clientes_agrupados);
				setOpciones(response.data.opciones);
				setOpcionesUsuario(response.data.opciones_usuario);
				setLoaded(true);
			} else {

				navigate('/');
			}

		} catch (error) {
			console.error("Error al cargar usuarios:", error);
			navigate('/');
		}
	}
	const handleEvent = (opcionId) => {

		switch (opcionId) {
			case 1:
				setOpen(true);

				// Lógica para la opción 1
				break;

			default:
				console.log("Lógica para una opción desconocida ");

				// Lógica para una opción desconocida
				break;
		}
	}

	return (
		<div className='menu-back fade-in2'>
			<SubHeader />
			<Typography variant="h4" gutterBottom>USUARIOS</Typography>
			{!loaded && (<CircularProgress />)}
			{loaded && (
				<>
					<Grid container direction={'column'} xs={12} >
						<OpcionesMenuFunc opciones={opciones} handleEvent={handleEvent}></OpcionesMenuFunc>
					</Grid>

					<Grid container direction="row" padding="1em" justifyContent={'space-around'} alignItems={'start'}>

						{/* Contenedor de Empleados */}
						<Grid container xs={12} sm={5} md={5} lg={5}>
							<Grid container direction="column" xs={12} justifyContent="center">
								<Typography variant="h5" gutterBottom>Empleados ({usuarios.length > 0 ? usuarios.length : ''})</Typography>
							</Grid>
							<Grid container
								direction="row"
								justifyContent="center"
								alignItems="center"
								xs={12}
								gap={2}
							>

								{usuarios.length > 0 ? (
									usuarios.map((usuario, index) => (
										<Grid item xs={12} sm={12} md={10} lg={5.5} xl={5} key={usuario.id}>
											<UsuarioCard usuario={usuario} opciones={opcionesUsuario} cargarUsuarios={cargarUsuarios} roles={roles} clientes={clientes} departamentos={departamentos} />
										</Grid>
									))
								) : (
									<p>No hay usuarios disponibles</p>
								)}
							</Grid>
						</Grid>

						{/* Contenedor de Clientes */}
						{usuariosClientes.length > 0 && (
							<Grid container xs={12} sm={5} md={5} lg={5}>
								<Grid container direction="row" xs={12} justifyContent="center">
									<Typography variant="h5" gutterBottom>Clientes ({usuariosClientesAgrupados.length})</Typography>
								</Grid>

								<Grid
									container
									direction="row"
									justifyContent="center"
									alignItems="center"
									xs={12}
									gap={2}
								>
									{usuariosClientesAgrupados.map((cliente, index) => (

										<Grid
											container
											direction="column"
											justifyContent="center"
											alignItems="center"
											xs={11.5} sm={12} md={12} lg={5.5} xl={5.5}
											gap={2}
											className="fichaje-card fade-in2"
											sx={{ width: '100%', padding: 2, borderRadius: 3, boxShadow: 3, background: "var(--fondoTarjeta)", minHeight: '10vh' }}
										>
											<Grid item xs={12}>
												<Typography variant="h6" style={{ fontWeight: 400}}>
													{cliente.nombre_cliente}
												</Typography>
											</Grid>


											<Button variant="outlined" size='medium' color="primary" onClick={() => setOpenCliente(cliente.cliente_id)}>
												Ver Usuarios <PersonIcon sx={{ ml: 1, mt: -0.3 }} />
											</Button>

											<Dialog
												fullWidth
												maxWidth="xl"
												open={openCleinte === cliente.cliente_id === true}
												onClose={handleClose}
											>
												<DialogContent className='App' style={{ minHeight: '80vh' }}>
													<Grid
														container
														direction="row"
														justifyContent="space-between"
														alignItems="center"
														xs={12}
													>
														<Typography variant="h4">{cliente.nombre_cliente}</Typography>

														<CancelIcon fontSize='medium' className='pointer' onClick={handleClose} />
													</Grid>

													<Divider sx={{ mt: 1, mb: 3 }}></Divider>
													<Grid
														container
														direction="row"
														justifyContent="center"
														alignItems="center"
														xs={12}
														gap={2}
													>
														{cliente.usuarios_clientes.map((info, index) => (
															<Grid
																container
																direction="column"
																justifyContent="center"
																alignItems="center"
																xs={11.5} md={2.5}
															>
																<UsuarioCard usuario={info} opciones={opcionesUsuario} cargarUsuarios={cargarUsuarios} roles={roles} clientes={clientes} departamentos={departamentos} />
															</Grid>
														))}

													</Grid>

												</DialogContent>
											</Dialog>
										</Grid>

									))}
								</Grid>


								{/* <Grid container xs={12} rowSpacing={3} columnSpacing={1} direction={'row'} justifyContent={"start"}>

									{usuariosClientes.length > 0 ? (
										usuariosClientes.map((usuario,) => (
											<Grid item xs={12} sm={12} md={8} lg={6} xl={4} key={usuario.id}>
												<UsuarioCard usuario={usuario} opciones={opcionesUsuario} cargarUsuarios={cargarUsuarios} roles={roles} clientes={clientes} departamentos={departamentos} />
											</Grid>
										))
									) : (
										<p>No hay usuarios de clientes disponibles</p>
									)}
								</Grid> */}
							</Grid>
						)}
					</Grid>

					{/* Formulario de creación de usuario */}
					{open && (
						<FormCrearUsuario
							open={open}
							setOpen={setOpen}
							cargarUsuarios={cargarUsuarios}
							departamentos={departamentos}
							roles={roles}
							clientes={clientes}
						/>
					)}
				</>
			)}
		</div>
	);
};